import(/* webpackMode: "eager" */ "/vercel/path0/src/app/newsletter/newsletter.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterSection"] */ "/vercel/path0/src/components/sections/NewsletterSection/index.tsx");
